import LegalDocumentPage from "../components/LegalDocumentPage";
import {
  EMPLOYEE_GUIDE_LINKS,
  EMPLOYEE_GUIDE_SECTIONS,
} from "../content/employeeGuideContent";
import { LEGAL_OPERATOR } from "../content/legalMeta";
import "../pages/app-workspace.css";

export default function EmployeeGuidePage() {
  return (
    <LegalDocumentPage
      standalone
      title="Инструкция для сотрудника"
      subtitle="Как пройти обучение в Telegram или MAX"
      heroLead={
        <>
          Эту страницу можно отправить сотрудникам вместе со ссылкой на программу.
          Здесь описано, что нажать после перехода по ссылке и что делать, если
          что-то не работает.
        </>
      }
      heroMeta={[
        "Для сотрудников компаний-клиентов InChat",
        "Telegram и MAX",
      ]}
      sections={EMPLOYEE_GUIDE_SECTIONS}
      footerLinks={EMPLOYEE_GUIDE_LINKS}
      footerNote={
        <>
          Если проблема на стороне компании (ссылка, доступ, подписка), обратитесь
          к HR или ответственному за обучение. Техническая поддержка InChat:{" "}
          <a href={`mailto:${LEGAL_OPERATOR.email}`}>{LEGAL_OPERATOR.email}</a>
          {" · "}
          <a
            href={LEGAL_OPERATOR.telegramUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {LEGAL_OPERATOR.telegram}
          </a>
        </>
      }
    />
  );
}
